module.exports = __webpack_public_path__ + "post-listing-cross-promotoe-ico-3-l0nDKjv.png";